// @ts-ignore
import { getLoginUinfo, getLoginShopid, getQueryValues } from '@RootCommon/utils'
import { isInApp } from '@RootCommon/utils/h5PC'

const getPcCommonParams = () => {
  const { uid = 0 } = getLoginUinfo() || {}
  const shop_id = getLoginShopid()
  return {
    shop_id,
    custom: {
      uid,
    },
  }
}

const getH5CommonParams = () => {
  const { userId, shopId } = getQueryValues() as any
  return {
    shop_id: shopId,
    custom: {
      uid: userId,
    },
  }
}

const mergeCommonParams = (params?: object) => {
  if (isInApp()) {
    const { custom, ...otherParams } = getH5CommonParams()
    return { ...otherParams, custom: { ...custom, ...(params || {}) } }
  } else {
    const { custom, ...otherParams } = getPcCommonParams()
    return { ...otherParams, custom: { ...custom, ...(params || {}) } }
  }
}

const mergeCommonParamsForMX = (params?: object) => {
  if (isInApp()) {
    const { custom, ...otherParams } = getH5CommonParams()
    return { ...otherParams,  ...custom, ...(params || {}) }
  } else {
    const { custom, ...otherParams } = getPcCommonParams()
    return { ...otherParams, ...custom, ...(params || {})  }
  }
}

export function lxPV (cid: string, params?: object) {
  const valLab = mergeCommonParams(params)
  // console.log('lxPV|valLab', valLab)
  // @ts-ignore
  window.LXAnalytics('pageView', valLab, null, cid)
}

// 灵犀上报 moduleClick
export function lxMC (bid: string, cid: any, params?: object) {
  const valLab = mergeCommonParams(params)
  // console.log('lxMC|valLab', valLab)
  // @ts-ignore
  window.LXAnalytics('moduleClick', bid, valLab, { cid })
}


export function lxMCNew (bid: string, cid: any, params?: object) {
  const valLab = mergeCommonParamsForMX(params)
  // @ts-ignore
  window.LXAnalytics('moduleClick', bid, valLab, { cid })
}

export function lxMV (bid: string, cid: any, params?: object) {
  const valLab = mergeCommonParams(params)
  // @ts-ignore
  window.LXAnalytics('moduleView', bid, valLab, { cid })
}
